import * as React from "react";
import { createRoot } from "react-dom/client";
// import ReactDOM from "react-dom";
import { Routes, Route, BrowserRouter } from 'react-router-dom';
// import * as serviceWorker from "./serviceWorker";

import './index.scss';

import HeroSelect from "@ds-components/Main/heroselect";
import SpotifyCallback from "./pages/callback";
import { theme } from "@ds-components/General/dotaspottotheme";
import ToastProvider from "@ds-components/General/ToastProvider";
import { useAuthStore } from "@/store/authStore";
// <=== 💸  MUI Stuff  💸 ===>
import { ThemeProvider } from "@mui/material/styles";
// serviceWorker.unregister();


const DotaSpottoApp = () => {
	React.useEffect(() => {
		useAuthStore.getState().checkAuth();
		return useAuthStore.getState().startExpiryPolling();
	}, []);

	return (
		<ThemeProvider theme={theme}>
			<ToastProvider />
			<BrowserRouter future={{
				v7_startTransition: true
			}}>
				<Routes>
					<Route path="/" element={<HeroSelect />} />
					<Route path="/callback" element={<SpotifyCallback />} />
				</Routes>
			</BrowserRouter>
		</ThemeProvider>
	);
}

const appContainer = document.getElementById("dotapick");
if (appContainer) {
	const appRoot = createRoot(appContainer!);
	appRoot.render(<DotaSpottoApp />);
} else {
	console.error("Failed to find the 'dotapick' element in the DOM");
}
// ReactDOM.render(<DotaSpottoApp />, document.getElementById("dotapick"));


